import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Box, ButtonBase, Typography } from "@mui/material";
import {
  ArrowOutwardRounded,
  WidgetsOutlined,
  AccountBalanceWalletOutlined,
  LocalParkingOutlined,
  RadarOutlined,
  HubOutlined,
  AdminPanelSettingsOutlined,
  AssessmentOutlined,
  ApartmentOutlined,
  BuildOutlined,
} from "@mui/icons-material";
import { panelSx, focusSx } from "./welcomeStyles";
const areaIcons = {
  Came: LocalParkingOutlined,
  FinOps: AccountBalanceWalletOutlined,
  Monitoreo: RadarOutlined,
  Noc: RadarOutlined,
  Jarvis: HubOutlined,
  "J.A.R.V.I.S": HubOutlined,
  Seguridad: AdminPanelSettingsOutlined,
  Tableros: AssessmentOutlined,
  Propiedades: ApartmentOutlined,
  Mantenimiento: BuildOutlined,
};
export default function ModuleCard({ module }) {
  const AreaIcon = areaIcons[module.area] || WidgetsOutlined;
  return (
    <ButtonBase
      component={Link}
      to={module.route}
      key={module.key}
      aria-label={`Abrir ${module.title}`}
      sx={{
        ...panelSx,
        ...focusSx,
        p: 2.5,
        textAlign: "left",
        display: "block",
        minWidth: 0,
        transition: "transform 160ms, box-shadow 160ms",
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: "0 8px 24px rgba(17,45,56,.08)",
          borderColor: "info.main",
        },
        "@media (prefers-reduced-motion: reduce)": {
          transition: "none",
          "&:hover": { transform: "none" },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Box
          sx={{
            bgcolor: "action.hover",
            color: "info.main",
            borderRadius: 2,
            width: 38,
            height: 38,
            display: "grid",
            placeItems: "center",
          }}
        >
          <AreaIcon sx={{ fontSize: "22px !important" }} />
        </Box>
        <Typography
          sx={{
            color: "text.secondary",
            fontSize: 10,
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: 0.8,
          }}
        >
          {module.area}
        </Typography>
      </Box>
      <Typography
        component="h3"
        sx={{ fontSize: 16, fontWeight: 700, color: "text.primary", mb: 1 }}
      >
        {module.title}
      </Typography>
      <Typography
        sx={{
          color: "text.secondary",
          fontSize: 12,
          lineHeight: 1.75,
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          minHeight: 42,
        }}
      >
        {module.purpose}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mt: 2.5,
        }}
      >
        <Typography sx={{ color: "info.main", fontSize: 12, fontWeight: 700 }}>
          Abrir módulo
        </Typography>
        <ArrowOutwardRounded sx={{ color: "info.main", fontSize: "18px !important" }} />
      </Box>
    </ButtonBase>
  );
}
ModuleCard.propTypes = {
  module: PropTypes.shape({
    route: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    purpose: PropTypes.string.isRequired,
    area: PropTypes.string.isRequired,
  }).isRequired,
};
